<template>
  <div id="HomePage">
    <div id="swiper" class="container-fuild">
      <div class="swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in swiperList" :key="index">
            <img
              style="width: 100%; height: 100%"
              class="swiper-lazy"
              v-if="item.type == 0"
              :src="item.url"
              alt="轮播图"
            />
            <video
              class="video_1"
              :controls="false"
              autoplay
              muted
              style="width: 100%"
              :src="item.url"
              v-if="item.type == 1"
            ></video>
          </div>
        </div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <section class="index_section index_section1" v-if="JSON.stringify(product) != '{}'">
      <div class="i_ttl">
        <div class="h2 f45">{{ product.mainTitle }}</div>
        <p class="f16">{{ product.mainDescription }}</p>
      </div>
      <div class="container">
        <div class="row gutter-22">
          <div class="col-lg-9 l">
            <div class="in">
              <div class="row row-in gutter-22">
                <div
                  class="col-md-4 col-sm-6 col-6"
                  v-for="(item, index) in product.list"
                  :key="item.typeId"
                  @click="goPage(1, item)"
                >
                  <div class="con">
                    <img :src="item.iconUrl" />
                    <span class="f20">{{ item.typeName }}</span>
                    <i class="arr"></i>
                  </div>
                </div>
                <!-- <div class="col-md-4  col-sm-6 col-6"  @click="goPage(1,{typeId:product.type.typeId})">
                  <div class="con" >
                    <div>
                      <img :src="product.type.iconUrl" />
                    </div>
                    <span class="f20">{{product.type.typeName}}</span>
                    <i class="arr"></i>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <div class="col-lg-3 r" @click="goPage(1, customObj)">
            <!-- <router-link to="/service"> -->
            <div class="con">
              <div class="a_img" :title="'ODM/OEM ' + $t('home.tip')">
                <img :src="customObj.iconUrl" :alt="'ODM/OEM ' + $t('home.tip')" />
              </div>
              <!-- ODM/OEM&nbsp;&nbsp;{{ $t("home.tip") }} -->
              <div class="a_txt" :title="'ODM/OEM ' + $t('home.tip')">
                <span class="f20" style="color: #555555">{{ customObj.typeName }}</span>
                <i class="arr"></i>
              </div>
            </div>
            <!-- </router-link> -->
          </div>
        </div>
      </div>
    </section>

    <section
      class="index_section2"
      :style="{ backgroundImage: 'url(' + url + ')' }"
      v-if="JSON.stringify(solution) != '{}'"
    >
      <div class="container">
        <div class="row gutter-0">
          <div class="col-lg-6 col-xs-12 l">
            <div class="in">
              <div class="i_ttl">
                <div class="h2 f45">{{ solution.mainTitle }}</div>
                <p class="f16">{{ solution.mainDescription }}</p>
              </div>
              <div class="s_list">
                <div
                  class="s_item"
                  v-for="(ite, index) in solution.list"
                  :key="ite.typeId"
                  @click="goPage(2, ite)"
                >
                  <i><img :src="ite.iconUrl" alt="" /></i>
                  <span class="f16">{{ ite.typeName }}</span>
                </div>
                <!-- <div class="s_item">
                  <i><img src="@/assets/hhdimg//icon1/6.png" alt=""></i>
                  <span class="f16">More</span>
                </div> -->
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xs-12 r" @click="goPage(4, {})">
            <div class="in">
              <div class="i_ttl">
                <div class="h2 f45">
                  {{ solution.children.length > 0 ? solution.children[0].title : "" }}
                </div>
                <p class="f16">
                  {{
                    solution.children.length > 0 ? solution.children[0].description : ""
                  }}
                </p>
              </div>

              <!-- <div class="btn_more" title="ODM/OEM Services">
                <span class="f16">{{ $t("home.gengduo") }}</span>
                <i class="arr"></i>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="Features section3" v-if="JSON.stringify(introduct) != '{}'">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-12">
            <div
              class="feature-right wow fadeInUp"
              data-wow-delay=".3s"
              @click="playVideo"
            >
              <video
                id="myVideo"
                :src="introduct.mediaUrl"
                width="100%"
                height="auto"
                style="object-fit: fill"
                :poster="introduct.bannerUrl[0]"
                controls="true"
                preload="none"
              ></video>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="feature-content">
              <div class="title">
                <!-- <span class="wow fadeInRight" data-wow-delay=".3s">{{
                  introduct.mainTitle
                }}</span> -->
                <h3 class="wow fadeInRight f45" data-wow-delay=".5s">
                  {{ introduct.mainDescription }}
                </h3>
              </div>
              <div
                class="feature-item wow fadeInUp"
                data-wow-delay=".5s"
                v-for="(item, index) in introduct.children"
                :key="index"
              >
                <div class="feature-thumb">
                  <!-- <i :class="'lni lni-' + item.iconUrl"></i> -->
                  <svgIcon className="lni" :iconName="item.iconUrl"></svgIcon>
                </div>
                <div class="banner-content">
                  <h2 class="title">{{ item.title }}</h2>
                  <p>{{ item.description }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- :class="[lang == 1 ? 'hight' : 'overlay']" -->
    <section
      id="fun-facts"
      class="fun-facts hight"
      v-if="JSON.stringify(dataStatistics) != '{}'"
      :style="{ backgroundImage: 'url(' + dataStatistics.url + ')' }"
    >
      <div class="fun-inner">
        <div class="container">
          <div class="row">
            <div
              class="col-lg-3 col-md-6 col-12"
              v-for="(ite, index) in dataStatistics.children"
              :key="index"
            >
              <div class="single-fun wow fadeIn" data-wow-delay=".3s">
                <div class="head">
                  <!-- <div class="icon"> -->
                  <!-- <i :class="'lni lni-' + ite.iconUrl"></i> -->
                  <!-- <svgIcon
                      className="lni icon-circle"
                      :iconName="ite.iconUrl"
                    ></svgIcon> -->
                  <!-- <i v-if="lang==0"
                      ><img
                        style="width: 30px; height: 30px"
                        :src="ite.iconUrl"
                        alt=""
                    /></i> -->
                  <!-- </div> -->
                  <div class="counter">
                    <span id="secondo1" class="countup" cup-end="2050">{{
                      ite.title
                    }}</span>
                  </div>
                  <h2>{{ ite.description }}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 合作伙伴展示 -->
    <div class="index_section index_section5" v-if="JSON.stringify(parnerObj) != '{}'">
      <div class="i_ttl">
        <div class="title1 h2 f45">{{ $t("media.tip30") }}</div>
      </div>
      <div
        id="swiper1"
        class="container-fluid"
        v-for="(item, index) in parnerObj.imgList"
        :key="index"
      >
        <!-- :class="'banner-swiper'+index" -->
        <div
          class="swiper-container swiper-container-initialized swiper-container-horizontal"
          :class="'banner-swiper' + index"
        >
          <!-- <div class="row"> -->
          <div class="swiper-wrapper">
            <div
              class="swiper-slide col-md-2 col-xs-8 wow fadeInUp d-flex justify-content-center mg-b"
              v-for="(ite, inde) in item"
              :key="ite.id"
            >
              <!-- <div
                  class="col-md-2 col-xs-8 wow fadeInUp d-flex justify-content-center mg-b"
                  data-wow-delay="0.1s" 
                >-->
              <div class="product_list">
                <!-- {{inde}}{{item.length}} -->
                <div class="img">
                  <img class="img-fluid w-100 h-100" :src="ite.iconUrl" alt="" />
                </div>
              </div>
              <!-- </div> -->
            </div>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>

    <div class="index_section index_section5" v-if="JSON.stringify(newInfo) != '{}'">
      <div class="i_ttl">
        <div class="title1 h2 f45">{{ newInfo.mainTitle }}</div>
        <p class="f16">{{ newInfo.mainDescription }}</p>
      </div>
      <div class="container">
        <div class="row gutter-30">
          <div
            class="col-md-6 l"
            @click="goPage(3, newInfo.type)"
            v-if="JSON.stringify(newInfo.type) != '{}'"
          >
            <div class="con">
              <a v-if="newInfo.type.coverUrl">
                <img :src="newInfo.type.coverUrl" />
              </a>
              <div class="txtwrap">
                <div class="title2" v-if="newInfo.type.newsTitle">
                  <div class="a_txt h2">
                    {{ newInfo.type.newsTitle }}
                  </div>
                </div>
                <span class="time" v-if="newInfo.type.newsTitle">{{
                  newInfo.type.createTime
                }}</span>
                <div class="f16 c666 lh18 sinfo"></div>
              </div>
            </div>
          </div>

          <div class="col-md-6 r">
            <div class="in">
              <div class="row row-in gutter-30">
                <div
                  class="col-md-6 col-sm-12"
                  v-for="(item, index) in newInfo.list"
                  @click="goPage(3, item)"
                >
                  <div class="con">
                    <a class="a_img" title="news title">
                      <img class="news_img" :src="item.coverUrl" />
                    </a>
                    <div class="txtwrap">
                      <a class="h3" title="news title">
                        <span class="f20">{{ item.newsTitle }}</span>
                      </a>
                      <span class="time">{{ item.createTime }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="more_box">
            <div
              class="index_section1"
              style="padding: 0px; background-image: none"
              @click="gotoNews"
            >
              <span class="moretext">{{ $t("home.more") }}</span>
              <i class="arr" style="margin-left: 10px"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 合作申请 -->
    <div class="index_section index_section5" v-if="JSON.stringify(newInfo) != '{}'">
      <div class="i_ttl">
        <div class="title1 h2 f45">{{ $t("media.tip31") }}</div>
      </div>
      <div class="container">
        <div class="row gutter-30">
          <div class="col-md-6 l" v-if="JSON.stringify(parnerObj.type) != '{}'">
            <div class="con_box">
              <!--  v-if="parnerUrl" -->
              <a v-if="parnerUrl">
                <!-- ../assets/img/fixedImg.png -->
                <img class="img-fluid w-100 h-100" :src="parnerUrl" />
              </a>
              <a v-else>
                <!-- ../assets/img/fixedImg.png -->
                <img class="img-fluid w-100 h-100" src="../assets/img/fixedImg.png" />
              </a>
            </div>
          </div>

          <div class="col-md-6 r">
            <div class="in">
              <div class="row row-in gutter-30">
                <el-form
                  :model="formdata"
                  :rules="rules"
                  ref="ruleForm"
                  label-width="100px"
                  class="demo-ruleForm"
                  label-position="top"
                >
                  <el-form-item :label="$t('media.tip32')" prop="name">
                    <el-input
                      :placeholder="$t('media.tip37')"
                      v-model="formdata.name"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('media.tip33')" prop="phone">
                    <el-input
                      :placeholder="$t('media.tip38')"
                      v-model="formdata.phone"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('media.tip34')" prop="email">
                    <el-input
                      :placeholder="$t('media.tip39')"
                      type="email"
                      v-model="formdata.email"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('media.tip35')" prop="companyName">
                    <el-input
                      :placeholder="$t('media.tip40')"
                      v-model="formdata.companyName"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="" prop="notes">
                    <el-input
                      :placeholder="$t('media.tip36')"
                      type="textarea"
                      resize="none"
                      v-model="formdata.notes"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">{{
                      $t("media.tip41")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </div>
  </div>
  </div> -->
</template>
<script>
import Swiper from "swiper";
import { homePage, addPartner } from "@/api/modules/home";
import { WOW } from "wowjs";
export default {
  name: "HomePage",
  metaInfo() {
    return {
      title: this.PageTitle,
      meta: this.mateList,
      link: [
        {
          // set link
          rel: "asstes",
          href: "https://assets-cdn.github.com/",
        },
      ],
    };
  },
  data() {
    return {
      formdata: {
        name: "",
        phone: "",
        email: "",
        companyName: "",
        notes: "",
      },
      product: {},
      solution: {},
      newInfo: {},
      introduct: {},
      dataStatistics: {},
      customObj: {},
      parnerObj: {},
      lang: this.$store.getters.lang,
      rules: {
        name: [{ required: true, message: this.$t("media.tip37"), trigger: "blur" }],
        phone: [
          { required: true, message: this.$t("media.tip38"), trigger: "blur" },
          { validator: this.validateNumber, trigger: "blur" }, //message: this.$t("media.tip43"),
        ],
        email: [{ type: "email", message: this.$t("media.tip44"), trigger: "blur" }],
        companyName: [
          { required: true, message: this.$t("media.tip40"), trigger: "blur" },
        ],
        notes: [{ required: true, message: this.$t("media.tip36"), trigger: "blur" }],
      },
      mateList: [
        {
          charset: "utf-8",
        },
        {
          name: "viewport",
          content:
            "width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0, user-scalable=no",
        },
      ],
      url: "",
      parnerUrl: "",
      name: "Home",
      swiperList: [],
      PageTitle: "",
      PagekeyWords: "",
      PageDescription: "",
      swperInstance: null,
      smallInstance0: null,
      smallInstance1: null,
    };
  },
  watch: {
    swiperList: {
      immediate: true,
      handler() {
        let that=this
        this.$nextTick(() => {
          // 确保DOM更新完成后，重新初始化Swiper
          if (this.swperInstance) {
            this.swperInstance.destroy();
          }
          /* banner-swiper */
          this.swperInstance = new Swiper(".banner-swiper", {
            loop: true, // 循环模式选项
            // autoplay:true,
            effect: "fade",
            //自动播放
            autoplay: {
              delay: 3000,
              stopOnLastSlide: false,
              disableOnInteraction: false,
            },
            // 如果需要分页器
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            // 如果需要前进后退按钮
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            on: {
              init: function () {
                that.setupVideoEvents();
              },
              slideChange: function () {
                console.log('3827347=====sssss',that.swperInstance)
                // 每次滑动后检查当前幻灯片是否有视频
                const currentSlide = that.swperInstance.slides[that.swperInstance.activeIndex];
                const video = currentSlide.querySelector(".video_1");
                // video.pause();
                // video.currentTime = 0;
                if (video) {
                  // 如果有视频，停止自动轮播
                  video.pause();
                  video.currentTime = 0;
                  that.swperInstance.autoplay.stop();

                  // 如果视频没有播放，则播放视频
                  if (video.paused) {
                    video.play().catch((e) => {
                      console.error("视频播放失败:", e);
                      video.currentTime = 0;
                      // 如果播放失败，恢复自动轮播
                      that.swperInstance.autoplay.start();
                    });
                  }
                } else {
                  // 如果没有视频，恢复自动轮播
                  that.swperInstance.autoplay.start();
                }
              },
            },
            // 延迟加载
            lazy: {
              loadPrevNext: true,
            },
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true, //修改swiper的父元素时，自动初始化swiper
          });
          /* customer-swiper */
          new Swiper(".customer-swiper", {
            loop: true, // 循环模式选项
            slidesPerView: 3,
            //自动播放
            autoplay: {
              delay: 3000,
              stopOnLastSlide: false,
              disableOnInteraction: false,
            },
            // 如果需要前进后退按钮
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true, //修改swiper的父元素时，自动初始化swiper
          });
          /* wowjs动画 */
          var wow = new WOW({
            boxClass: "wow",
            animateClass: "animated",
            offset: 0,
            mobile: true,
            live: true,
          });
          wow.init();
        });
      },
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    setupVideoEvents() {
      let that=this
      const videos = document.querySelectorAll(".swiper-slide video");
      console.log('3293882========fdfdfhdh1111',that.swperInstance)
      videos.forEach((video) => {
        // 确保视频不会自动播放（由Swiper控制）
        // video.removeAttribute("autoplay");

        // 当视频播放时，停止 Swiper 的自动轮播
        video.addEventListener("play", function () {
          that.swperInstance.autoplay.stop();
        });

        // 当视频结束时，恢复 Swiper 的自动轮播并切换到下一张
        video.addEventListener("ended", function () {
          
          video.pause();
          video.currentTime = 0;
          that.swperInstance.autoplay.start();
          that.swperInstance.slideNext();
        });

        // 处理视频加载错误
        video.addEventListener("error", function () {
          console.error("视频加载错误，继续轮播");
          that.swperInstance.autoplay.start();
        });
      });
    },

    validateNumber(rule, value, callback) {
      const numberRegex = /^\d+$/;
      if (!numberRegex.test(value)) {
        callback(new Error(this.$t("media.tip43")));
      } else {
        callback();
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let postdata = {
            name: this.formdata.name,
            companyName: this.formdata.companyName,
            description: this.formdata.notes,
            email: this.formdata.email,
            phone: this.formdata.phone,
            language: this.$store.getters.lang,
          };
          addPartner(postdata).then((res) => {
            if (res.returnCode == 200) {
              this.$message({
                message: this.$t("media.tip42"),
                type: "success",
              });
              this.formdata.name = "";
              this.formdata.companyName = "";
              this.formdata.notes = "";
              this.formdata.email = "";
              this.formdata.phone = "";
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    playVideo() {
      var video = document.getElementById("myVideo");
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    },
    getList() {
      let data = {
        page: 0,
        language: this.$store.getters.lang,
      };
      console.log("7777===lang",this.$store.getters.lang)
      homePage(data).then((res) => {
        if (res.returnCode == 200) {
          res.data.forEach((item) => {
            this.mateList.push({
              name: item.seoKeyWord,
              content: item.seoContent,
            });
            if (item.moduleType == 2) {
              this.product = item;
              this.product["list"] = this.product.productTypeVo.childTypeList
                ? this.product.productTypeVo.childTypeList
                : [];
              this.product["type"] = this.product.productTypeVo.mainType
                ? this.product.productTypeVo.mainType
                : {};
              this.customObj = this.product.productTypeVo.customType
                ? this.product.productTypeVo.customType
                : {};
            }
            if (item.moduleType == 3) {
              this.solution = item;
              this.url = item.baseUrl.split(";")[0];
              this.solution["list"] = this.solution.solutionTypeVo.childTypeList
                ? this.solution.solutionTypeVo.childTypeList
                : [];
              this.solution["type"] = this.solution.solutionTypeVo.mainType
                ? this.solution.solutionTypeVo.mainType
                : {};
            }
            if (item.moduleType == 5) {
              this.newInfo = item;
              this.newInfo["list"] =
                this.newInfo.newsVo && this.newInfo.newsVo.childNewsList
                  ? this.newInfo.newsVo.childNewsList
                  : [];
              this.newInfo["type"] =
                this.newInfo.newsVo && this.newInfo.newsVo.mainNews
                  ? this.newInfo.newsVo.mainNews
                  : {};
            }
            if (item.moduleType == 4) {
              this.introduct = item;
              this.introduct.bannerUrl = this.introduct.baseUrl.split(";");
            }
            if (item.moduleType == 1) {
              this.PageTitle = item.seoTitle;
              this.swiperList = item.bannerUrl.split(";").map((item) => {
                let obj = {}
                if(item.includes('mp4')){
                  obj['type']=1
                  obj['url']=item
                }else{
                  obj['type']=0
                  obj['url']=item
                }
                return obj;
              });
              // this.swiperList.unshift({
              //   type: 1,
              //   url: "@/assets/img/1.mp4",
              // });
            }
            if (item.moduleType == 8) {
              this.dataStatistics = item;
              this.dataStatistics.url = item.baseUrl && item.baseUrl.split(";")[0];
            }
            // 合作伙伴
            if (item.moduleType == 9) {
              // this.parnerObj = item;
              let imgList = [];
              let list = [];
              item.cooperatePartnerList.forEach((ite) => {
                list.push(ite);
                if (list.length == 6 && imgList.length != 2) {
                  imgList.push(list);
                  list = [];
                }
              });
              if (list.length > 0) {
                if (imgList.length == 2) {
                  let len = Math.floor(list.length / 2);
                  let first = list.slice(0, len);
                  let secon = list.slice(len);
                  imgList[0].push(...first);
                  imgList[1].push(...secon);
                } else {
                  imgList.push(list);
                }
              }

              this.parnerObj = { ...item, imgList: imgList };
              console.log("3290329=====img", imgList, this.parnerObj);
              this.initSmallBanner();
            }
            if (item.moduleType == 11) {
              this.parnerUrl = item.bannerUrl;
            }
          });
          // parnerUrl
          console.log("hjfjd====kkkk", this.swiperList);
        }
      });
    },

    initSmallBanner() {
      let that = this;
      this.$nextTick(() => {
        /* banner-swiper */
        // 确保DOM更新完成后，重新初始化Swiper
        if (that.smallInstanc0 != null) {
          that.smallInstance0.destroy();
          that.smallInstanc0 = null;
        }
        if (this.smallInstance1 != null) {
          that.smallInstance1.destroy();
          that.smallInstance1 = null;
        }
        if (this.parnerObj.imgList.length > 0 && this.parnerObj.imgList[0].length >= 6) {
          that.smallInstance0 = new Swiper(".banner-swiper0", {
            freeMode: true,
            loop: true, // 循环模式选项
            cache: false,
            slidesPerView: "auto",
            spaceBetween: 15,
            effect: "slide",
            onTransitionEnd: function (swiper) {
              if (swiper.progress == 1) {
                swiper.activeIndex = swiper.slides.length - 1;
              }
            },
            //自动播放
            autoplay: {
              delay: 1000,
              stopOnLastSlide: false,
              disableOnInteraction: false,
            },
            speed: 500,
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true, //修改swiper的父元素时，自动初始化swiper
          });
        }

        if (this.parnerObj.imgList.length == 2 && this.parnerObj.imgList[1].length >= 6) {
          that.smallInstance1 = new Swiper(".banner-swiper1", {
            freeMode: true,
            loop: true, // 循环模式选项
            cache: false,
            slidesPerView: "auto",
            spaceBetween: 15,
            effect: "slide",
            onTransitionEnd: function (swiper) {
              if (swiper.progress == 1) {
                swiper.activeIndex = swiper.slides.length - 1;
              }
            },
            //自动播放
            autoplay: {
              delay: 1000,
              stopOnLastSlide: false,
              disableOnInteraction: false,
            },
            speed: 500,
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true, //修改swiper的父元素时，自动初始化swiper
          });
        }

        /* wowjs动画 */
        var wow = new WOW({
          boxClass: "wow",
          animateClass: "animated",
          offset: 0,
          mobile: true,
          live: true,
        });
        wow.init();
      });
    },

    // 跳转页面
    goPage(type, item) {
      console.log("8797====dfdf", item);
      switch (type) {
        case 1:
          this.$router.push({
            path: "/products",
            query: {
              id: item.typeId,
            },
          });
          break;
        case 2:
          this.$router.push({
            path: "/service",
            query: {
              id: item.typeId,
            },
          });
          break;
        case 3:
          this.$router.push({
            path: "/newInfo",
            query: {
              data: encodeURIComponent(
                JSON.stringify({ ...item, newsId: item.id, Lname: this.name })
              ),
            },
          });
          break;
        case 4:
          this.$router.push({
            path: "/case",
          });
          break;
        default:
          break;
      }
    },

    gotoNews() {
      this.$router.push({
        path: "/newsinformation",
      });
    },
  },
};
</script>
<style scoped>
/* @-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
  }
} */
/* 使用 !important 来确保样式覆盖 */
/* .swiper-slide-duplicate,.swiper-slide-clone {
    display: none !important;
} */

/deep/ .el-form-item__label {
  font-size: 16px;
}
/deep/ .el-input__inner {
  font-size: 16px;
}
/deep/ .el-button {
  width: 100%;
  margin-top: 15px;
}
/deep/ .el-textarea__inner {
  height: 120px;
  font-size: 17px;
}
.product_list {
  width: 200px;
  height: 80px;
}

.img {
  height: 80px;
}
.mg-b {
  margin-bottom: 15px;
}
.wh45 {
  width: 45px;
  height: 45px;
}
/* 整体盒子 */
#HomePage {
  width: 100%;
  min-height: 300px;
}

/* 轮播图 */
#swiper {
  height: 750px;
  /* height:100%; */
}

#swiper .banner-swiper {
  width: 100%;
  height: 100%;
}

#swiper .banner-swiper .swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

#swiper .banner-swiper .swiper-slide {
  width: 100%;
  background-color:#fff;
  position: relative;
}

#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(51, 51, 51, 0.534);
  text-align: center;
  line-height: 80px;
}

#swiper .banner-swiper .swiper-slide-title > h1 {
  font-size: 50px;
  margin-top: 12%;
}

#swiper .banner-swiper .swiper-slide-title > p {
  font-size: 20px;
  margin-top: 1%;
  font-weight: 700;
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  #swiper {
    height: 200px;
  }

  #bigData {
    padding: 30px;
  }

  #bigData .bigData-title {
    font-size: 20px;
  }

  #bigData .bigData-device {
    font-size: 20px;
    margin: 10px 0 10px;
  }

  #contactUs {
    height: 200px;
    transition: all ease 0.6s;
  }

  #contactUs .contactUs-container {
    padding-top: 0;
  }

  #contactUs .contactUs-container h1 {
    font-size: 25px;
  }

  #contactUs .contactUs-container h2 {
    font-size: 18px;
  }

  #contactUs .contactUs-container h3 {
    font-size: 18px;
  }

  #contactUs .contactUs-container button {
    width: 200px;
    height: 30px;
    margin-top: 20px;
  }

  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin: 10px;
  }

  #customer {
    padding: 30px 0;
    box-sizing: border-box;
    background: #fff;
  }

  #customer .customer-title {
    font-size: 16px;
    font-weight: bold;
  }

  #customer .customer-logo img {
    width: 48px;
    height: 48px;
  }

  #customer .customer-block {
    padding: 30px;
  }

  #customer .customer-block > div {
    padding: 30px 0;
  }

  #whyChooseUs {
    padding: 20px 0;
    transition: all ease 0.6s;
  }

  #whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
    font-size: 20px;
    font-weight: 700;
  }

  #whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
    font-size: 12px;
  }

  #whyChooseUs .server-block {
    padding: 50px 0;
    border: 1px solid #ccc;
    border-bottom: 5px solid #ccc;
  }

  #whyChooseUs .server-block img {
    width: 48px;
    height: 48px;
  }

  #whyChooseUs .server-block > p {
    font-size: 20px;
    margin: 30px 0;
  }

  #whyChooseUs .server-block > div {
    color: #ccc;
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  #swiper {
    height: 400px;
  }

  #bigData {
    padding: 60px;
  }

  #bigData .bigData-title {
    font-size: 30px;
  }

  #bigData .bigData-device {
    font-size: 30px;
    margin: 30px 0 15px;
  }

  #contactUs {
    height: 300px;
  }

  #contactUs .contactUs-container {
    padding-top: 50px;
  }

  #contactUs .contactUs-container h1 {
    font-size: 30px;
  }

  #contactUs .contactUs-container h3 {
    font-size: 20px;
  }

  #contactUs .contactUs-container button {
    width: 300px;
    height: 50px;
    margin-top: 30px;
  }

  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 32px;
    height: 32px;
    margin: 15px;
  }

  #customer .customer-title {
    font-size: 24px;
  }

  #whyChooseUs {
    padding: 20px 0;
  }
}

/* ================= */
.index_section1 {
  background-image: url("../assets/hhdimg/home_bg1.jpg");
}

.index_section1 {
  padding: 35px 0 60px;
  text-align: center;
}

.i_ttl {
  text-align: center;
  margin-bottom: 40px;
}

.i_ttl .h2 {
  position: relative;
  text-align: center;
  display: inline-block;
  font-family: galano, sans-serif;
  font-weight: 700;
}

.index_section1 .con {
  border: 1px solid #e3e4e5;
  margin-bottom: 25px;
  padding: 30px;
}

.index_section1 .con img {
  width: 100%;
}

.con_box {
  height: 100%;
  /* border: 1px solid #e3e4e5;
  margin-bottom: 25px;
  padding: 30px; */
}

.con_box img {
  width: 100%;
  height: 100%;
}

.index_section1 .i_ttl .h2 {
  position: relative;
  text-align: center;
  display: inline-block;
  font-family: galano, sans-serif;
  font-weight: 700;
}

.index_section1 .i_ttl .h2 + p {
  color: #666;
}

.index_section1 .a_txt span {
  display: inline-block;
  position: relative;
  top: 4px;
}

.index_section1 .r .con {
  padding: 13px 0;
  height: calc(100% - 25px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* height: 648.75px; */
}

.index_section1 .r .con {
  background: none;
}

.index_section1 .r .a_img {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.f20 {
  font-size: 20px;
}

.index_section1 .arr {
  display: inline-block;
  width: 28px;
  height: 28px;
  background: transparent;
  border: 1px solid #333;
  border-radius: 50%;
  vertical-align: middle;
  transition: all 0.5s;
  margin-left: 1em;
  line-height: 28px;
  text-align: center;
}

.index_section1 .arr::before {
  position: relative;
  content: "";
  display: inline-block;
  width: 0.6em;
  height: 0.6em;
  border-right: 1px solid #000;
  border-top: 1px solid #000;
  transform: rotate(45deg);
  margin-right: 0.3em;
  top: -0.1em;
}

/* ================================= */
.index_section2 {
  /* background: url(../assets/hhdimg/home_bg2.jpg) center; */
  background-repeat: no-repeat;
  background-size: 100% 100%; /* 或者其他你需要的大小设置 */
  background-position: center center; /* 水平垂直居中 */
  padding-bottom: 80px;
}

.index_section2 .l .in {
  padding-top: 20px;
}

.index_section2 .i_ttl {
  text-align: left;
  color: #fff;
  margin-bottom: 30px;
}

.index_section2 .i_ttl .h2 {
  position: relative;
  text-align: center;
  display: inline-block;
  font-family: galano, sans-serif;
  font-weight: 700;
  line-height: 1.1;
  margin-top: 20px;
  margin-bottom: 10px;
  color: #fff;
}

.index_section2 .i_ttl .h2 + p {
  color: #fff;
  position: relative;
  line-height: 1.9;
}

.index_section2 .s_list {
  margin-right: 80px;
  display: flex;
  flex-wrap: wrap;
  column-gap: 6px;
}

.index_section2 .s_item {
  background: rgb(255 255 255/10%);
  padding: 15px 25px 23px;
  flex: 1 1 calc(26% - 6px);
  margin-bottom: 6px;
  transition: all 0.4s;
  text-align: center;
}

.index_section2 .s_item a {
  display: block;
}

.index_section2 .r .in {
  padding-left: 100px;
  padding-top: 20px;
  text-align: left;
}

.index_section2 .r .i_ttl {
  margin-bottom: -50px;
}

.index_section2 .i_ttl {
  text-align: left;
  color: #fff;
  margin-bottom: 70px;
}

.index_section2 .r .btn_more {
  color: #fff;
  background: #036eb8;
  display: inline-block;
  padding: 8px 20px;
  line-height: 1.4;
  margin-top: 60px;
  vertical-align: middle;
}

.index_section2 .i_ttl .h2:after {
  margin-left: 0;
  /* content: url(/static/images/dot2.png); */
  position: relative;
  top: 35px;
}

.index_section2 .s_item span {
  color: #fff;
}

.index_section2 .s_item i {
  display: block;
  width: 76px;
  height: 76px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 8px;
}

.index_section2 .r .i_ttl .h2:after {
  visibility: hidden;
}

.index_section2 .arr {
  display: inline-block;
  width: 28px;
  height: 28px;
  background: transparent;
  border: 1px solid #fff;
  border-radius: 50%;
  vertical-align: middle;
  transition: all 0.5s;
  margin-left: 1em;
  line-height: 28px;
  text-align: center;
}

.index_section2 .arr::before {
  position: relative;
  content: "";
  display: inline-block;
  width: 0.6em;
  height: 0.6em;
  border-right: 1px solid #fff;
  border-top: 1px solid #fff;
  transform: rotate(45deg);
  margin-right: 0.3em;
  top: -0.1em;
}

.f45 {
  font-size: 45px;
}

.f16 {
  font-size: 16px;
}

/*  */
.index_section5 .con {
  background: #fff;
}

.index_section5 .r .col-md-6 {
  margin-top: 10px;
}
h6,
.h6,
h5,
.h5,
h4,
.h4,
h3,
.h3,
h2,
.h2,
h1,
.h1 {
  margin-bottom: 0px;
}

.more_box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
  font-size: 20px;
  cursor: pointer;
}

.moretext {
}

/* .more_box1 .arr {
  display: inline-block;
  width: 28px;
  height: 28px;
  background: transparent;
  border: 1px solid #333;
  border-radius: 50%;
  vertical-align: middle;
  transition: all 0.5s;
  margin-left: 1em;
  line-height: 28px;
  text-align: center;
}

.more_box1 .arr::before {
  position: relative;
  content: "";
  display: inline-block;
  width: 0.6em;
  height: 0.6em;
  border-right: 1px solid #fff;
  border-top: 1px solid #fff;
  transform: rotate(45deg);
  margin-right: 0.3em;
  top: -0.1em;
} */

element.style {
}

@media screen and (max-width: 1366px) .index_section5 .a_img {
}

@media screen and (max-width: 1440px) .index_section5 .a_img {
}

.index_section5 .a_img {
  position: relative;
  overflow: hidden;
  height: 153px;
}

.index_section5 .txtwrap {
  padding: 10px 30px 8px;
}

.index_section5 .h3 {
  /* margin-top: 20px; */
  display: inline-block;
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.index_section5 .h2 {
  /* margin-top: 20px; */
  display: inline-block;
  width: 600px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* .index_section5 .title2 {
  display: inline-block;
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.index_section5 .title3 {
  display: inline-block;
  width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}  */

.index_section5 .time {
  font-size: 14px;
  color: #999;
  display: block;
  /* margin-top: 5px; */
}

.index_section5 .sinfo {
  margin: 18px 0 30px;
}

.index_section5 .btn_more {
  margin: 0;
  position: absolute;
  z-index: 3;
  bottom: 15px;
  right: 0;
  cursor: pointer;
}

.index_section5 {
  text-align: left;
  background-image: url("../assets/hhdimg/bg5.jpg");
  padding-bottom: 40px;
  padding-top: 40px;
}

.index_section5 .news_img {
  height: 187px;
}

.index_section5 .i_ttl .h2:after {
  display: block;
  width: 60px;
  height: 12px;
  margin: -10px auto 37px;
  z-index: 22;
}

.index_section5 .l .con {
  position: relative;
  overflow: hidden;
  display: block;
  margin-top: 10px;
}

.index_section5 img {
  width: 100%;
  height: auto;
  transition: all 0.3s;
}

/*  */

/*=============================
	03. Start Features CSS
===============================*/
.section3 {
  padding-top: 100px;
  padding-bottom: 80px;
  position: relative;
}

.Features {
  background: #fff;
}

.Features .feature-content {
  padding-left: 50px;
  padding-bottom: 30px;
}

.Features .feature-content .title {
  margin-bottom: 5px;
}

.Features .feature-content .title span {
  text-transform: capitalize;
  font-size: 14px;
  display: inline-block;
  background: #0c74b5;
  color: #fff;
  padding: 4px 18px;
  margin-bottom: 5px;
}

.Features .feature-content .title h3 {
  font-size: 40px;
  line-height: 50px;
  font-weight: 700;
}

.Features .feature-item {
  /* margin-bottom: 15px; */
  position: relative;
  padding-left: 80px;
  padding-right: 30px;
}

.Features .feature-item:last-child {
  margin-bottom: 0;
}

.Features .feature-item .feature-thumb {
  height: 55px;
  width: 55px;
  background: url("../assets/hhdimg/feature-icon-bg.png") no-repeat center center;
  background-size: contain;
  font-size: 23px;
  line-height: 55px;
  text-align: center;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 10px;
}
.Features .feature-item .feature-thumb .lni {
  color: #fff;
}
.Features .feature-item .banner-content {
  /*! padding-left: 34px; */
  display: inline-block;
}

.Features .feature-item .banner-content .title {
  font-weight: 700;
  text-transform: capitalize;
  margin-bottom: 0px;
  font-size: 18px;
  font-weight: 600;
  line-height: 38px;
}

.Features .feature-item .banner-content p {
  color: #777;
  font-weight: 400;
  font-size: 14px;
  display: block;
  /* margin-top: 6px; */
  margin-top: -5px;
}

.feature-right {
  position: relative;
  /* background-image: url('../assets/hhdimg/feature-image.jpg'); */
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
}

/*=============================
	End Features CSS
===============================*/

/*=================================
	10. Start FunFacts CSS
===================================*/

.fun-facts {
  padding: 0;
  /* background-image: url(../assets/hhdimg/nav5.jpg); */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.hight {
  height: 353px;
}

.fun-facts.overlay::before {
  opacity: 0.7;
  background: #000;
}

.overlay {
  position: relative;
}

.overlay::before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: #000;
  content: "";
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.fun-facts .fun-inner {
  padding: 70px 0 100px;
}

.fun-facts .single-fun {
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-align: center;
  position: relative;
  margin-top: 30px;
  text-align: center;
  box-shadow: none;
  z-index: 3;
  padding: 0 30px;
}

.fun-facts .single-fun .head {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.fun-facts .single-fun .icon {
  width: 80px;
  height: 80px;
  display: flex;
  color: rgb(12, 116, 181);
  /* align-items:center; */
  justify-content: center;
  /* text-align: center; */
  border-radius: 100%;
  line-height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  /* -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease; */
  background: rgba(255, 255, 255, 0.5);
}
.fun-facts .single-fun .icon-circle {
  width: 70px;
  height: 70px;
  box-sizing: border-box;
  color: #fff;
  /* align-items:center; */
  justify-content: center;
  /* text-align: center; */
  border-radius: 100%;
  background: rgb(12, 116, 181);
}
.fun-facts .single-fun .icon-circle:hover {
  color: rgb(12, 116, 181);
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
  background: rgba(255, 255, 255, 0.5);

  /* transform: rotateY(360deg); */
  -webkit-transform: rotate(360deg);

  /* animation: rotation 3s linear infinite;
  -moz-animation: rotation 3s linear infinite;
  -webkit-animation: rotation 3s linear infinite;
  -o-animation: rotation 3s linear infinite; */
}

.fun-facts .single-fun .icon i {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* .fun-facts .single-fun:hover .icon {
  background: transparent;
} */

/* .fun-facts .single-fun i {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 30px;
  width: 66px;
  height: 66px;
  line-height: 66px;
  border-radius: 100%;
  color: #fff;
  background: #0c74b5;
  top: 6px;
  position: relative;
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
  display: inline-block;
} */

.fun-facts .single-fun:hover i {
  transform: scale(1.2) rotate(360deg);
  background: #d4e6e7;
  color: #0c74b5;
}

.fun-facts .counter {
  color: #fff;
  font-size: 32px;
  font-weight: 600;
  position: relative;
  margin-top: 30px;
  margin-bottom: 10px;
}

.fun-facts .single-fun h2 {
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  text-transform: capitalize;
}

.fun-facts .single-fun p {
  color: #fff;
  margin-top: 20px;
}

/*=================================
	End FunFacts CSS
===================================*/

@media screen and (max-width: 992px) {
  #swiper .banner-swiper .swiper-slide img {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
  .navbar {
    padding-left: 16px;
    order: 13;
    width: 100%;
    padding: 0;
    border-top: 1px solid rgb(99 159 200/20%);
  }
  .index_section1 .arr {
    display: none;
  }
  .index_section1 .a_img img {
    display: block;
    margin: 0 auto;
    max-width: 150px;
  }
  .index_section1 .r .con {
    height: 224px !important;
  }
  .index_section2 {
    background: #0565a7 !important;
  }

  .index_section2 .s_list {
    margin-right: 0 !important;
    margin-left: auto;
  }

  .index_section2 .r .in {
    padding-left: 0px !important;
    text-align: center !important;
  }

  .index_section2 .r .in p {
    text-align: center !important;
  }

  .index_section2 .r .in .h2 {
    text-align: center !important;
    width: 100%;
  }

  .f20 {
    font-size: 16px !important;
  }

  .f45 {
    font-size: 24px !important;
  }

  .index_section2 .i_ttl .h2 {
    width: 100%;
  }

  .index_section2 .f16 {
    text-align: center;
  }

  .section3 {
    padding-top: 20px;
    padding-bottom: 20px;
    position: relative;
  }

  .feature-content {
    margin-top: 30px;
    padding: 0 !important;
  }

  .btn_more i.arr {
    display: none;
  }

  .changecolor {
    display: block;
  }

  .attach1 {
    height: 0 !important;
  }

  .navbar {
    min-height: 0px !important;
    margin-bottom: 0px !important;
  }

  .navbar-toggle:focus {
    background: none !important;
    border: none !important;
  }

  .leftline {
    font-size: 18px !important;
  }

  .crumbs {
    font-size: 14px !important;
  }

  .about .pagecontent .w50 {
    width: 100% !important;
  }

  .entry-content p {
    margin-bottom: 0px !important;
  }

  .about .f24 {
    font-size: 18px !important;
  }

  .about .pad30 {
    padding: 0 !important;
  }

  .remark #ourteam .ul1 {
    display: block !important;
  }

  .remark #ourteam .ul1 li {
    margin: 8px 0px !important;
  }

  .remark #ourteam .ul2 li i {
    width: 64px;
    min-width: 0;
    height: 64px;
    flex: 0 0 74px;
    border: none;
  }

  .remark #ourteam .ul2 li {
    align-items: start !important;
  }

  .remark #ourteam .ul2 li img {
    max-width: 100%;
    max-height: 100%;
  }

  #rddirection .ul1 {
    display: block !important;
  }

  #productdetailpage .allpics .hdl {
    cursor: pointer;
  }

  .product_info .fea ul img {
    width: 35px !important;
  }

  .product_info .fea ul span {
    font-size: 14px !important;
  }

  .product_main_content li {
    font-size: 14px !important;
  }

  .content_slider_hdl div.slick-slide {
    padding: 12px 4px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/HomePage.vue